import { Form, Input } from "antd";
import React from "react";

const DeviceReferenceId: React.FC = () => {
  return (
    <Form.Item
      name="referenceId"
      label="Reference ID"
      rules={[
        {
          required: true,
          message: "Please enter the reference ID",
        },
      ]}
    >
      <Input />
    </Form.Item>
  );
};

export default DeviceReferenceId;
